import { useEffect, useState } from "react";
import ScrollTrigger from "react-scroll-trigger";

const Counter = ({ number, speed = 70 }) => {
  const decimals = (number.toString().split(".")[1] || "").length;
  const step = decimals > 0 ? 1 / 10 ** decimals : 1;

  const [currentNumber, setCurrentNumber] = useState(0);
  const [running, setRunning] = useState(false);

  useEffect(() => {
    if (running && currentNumber < number) {
      const timeout = setTimeout(() => {
        const next = Math.min(currentNumber + step, number);
        setCurrentNumber(parseFloat(next.toFixed(decimals)));
      }, speed);
      return () => clearTimeout(timeout);
    }
  }, [number, currentNumber, running]);

  return <ScrollTrigger onEnter={() => setRunning(true)}>{currentNumber.toFixed(decimals)}</ScrollTrigger>;
};

export default Counter;
